import React, { useState } from "react";

import { cl } from "../../../../utilities/cl";
import { isFunc } from "../../../../utilities/isFunc";

import Button from "../../../Button";
import Group from "../Group/Group";
import Select from "../../../Form/Select";
import Tags from "../../../Tags";

import SvgPlusCyrcle from "../../../SVG/PlusCircle";

const SettingsTags = ({
  className = "",
  name,
  value = [],
  allTags = [],
  onChange,
}) => {
  const [inputTagName, setInputTagName] = useState("");
  const [searchWord, setSearchWord] = useState("");

  const wrapperClass = cl(className, "SettingsTags");

  // Нормализуем value в массив строк
  const currentTags = normalizeToArray(value);

  const hChange = ({ value: selectedValues }) => {
    console.log({ selectedValues });

    if (isFunc(onChange)) {
      onChange({
        name,
        value: selectedValues,
      });
    }
  };

  const hChangeInput = (value) => setSearchWord(value);

  const hKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTags();
    }
  };

  // Доступные для выбора теги (исключаем уже выбранные)
  // const tagsForSelect = allTags;
  //   allTags.filter((t) => !currentTags.includes(String(t.value || t.title)));

  const addTags = () => {
    const rawInput = inputTagName === "0" ? "" : inputTagName;
    const inputs = [];

    if (rawInput) {
      inputs.push(
        ...rawInput
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean),
      );
    }
    if (searchWord.trim()) {
      inputs.push(searchWord.trim());
    }

    if (inputs.length === 0) return;

    // Фильтруем дубликаты и уже существующие
    const newTags = inputs.filter((tag, index) => {
      const normalizedTag = String(tag);
      return (
        normalizedTag &&
        !currentTags.includes(normalizedTag) &&
        inputs.findIndex((t) => String(t) === normalizedTag) === index
      );
    });

    if (newTags.length === 0) {
      setInputTagName("");
      setSearchWord("");
      return;
    }

    const nextTags = [...currentTags, ...newTags.map(String)];

    if (isFunc(onChange)) {
      onChange({
        name,
        value: nextTags,
      });
    }

    setInputTagName("");
    setSearchWord("");
  };

  const deleteTag = ({ name: tagName }) => {
    const nextTags = currentTags.filter(
      (tag) => String(tag) !== String(tagName),
    );

    if (isFunc(onChange)) {
      onChange({
        name,
        value: nextTags,
      });
    }
  };

  return (
    <Group className={wrapperClass} columns={1}>
      <div>
        <div className="SettingsTags__header" onKeyDown={hKeyDown}>
          <Select
            label="Список меток"
            type="options"
            placeholder="Название новой метки"
            multiple={true}
            selected={currentTags}
            resetMultiple={{
              title: "Убрать",
              value: "",
            }}
            search={true}
            searchWord={searchWord}
            options={allTags}
            sortAlphabetically
            onChange={hChange}
            onChangeInput={hChangeInput}
          />

          <div>
            <Button
              type="string"
              title="Добавить тег"
              onClick={addTags}
              disabled={!inputTagName.trim() && !searchWord.trim()}
            >
              <SvgPlusCyrcle size="sm3" variant="dark-lg" />
            </Button>
          </div>
        </div>

        <Tags tags={buildTagsList(currentTags)} onDelete={deleteTag} />
      </div>
    </Group>
  );
};

export default SettingsTags;

//
// Вспомогательные функции
//

function buildTagsList(tags) {
  if (!Array.isArray(tags)) return [];

  return tags.map((tagName) => ({
    id: String(tagName),
    name: String(tagName),
  }));
}

function normalizeToArray(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.map(String);
  if (typeof value === "string") {
    return value.split(",").filter(Boolean).map(String);
  }
  return [String(value)];
}
